'use client'

import { textErrorColor } from '@/core/constants/class-names'
import { cn } from '@/core/lib/utils/cn'
import { Button, ButtonProps } from '@/core/ui/atoms/button'
import { usePaymentStore } from '../store'
import { usePayment } from './use-stripe-payment'

interface PaymentButtonProps
  extends Omit<
    ButtonProps,
    'onClick' | 'loading' | 'disabled' | 'onError' | 'onSuccess'
  > {
  clientSecret?: string
  onSuccess?: () => void
  onError?: (err: string) => void
}

export const StripeButton: React.FC<PaymentButtonProps> = ({
  clientSecret,
  onSuccess,
  onError,
  ...rest
}) => {
  const { handlePayment, isPending, isError, error } = usePayment()
  const { isValid } = usePaymentStore()

  return (
    <div>
      <Button
        type='button'
        onClick={() =>
          handlePayment(clientSecret, {
            onSuccess,
            onError,
          })
        }
        disabled={isPending || !isValid}
        loading={isPending}
        {...rest}
      />

      {isError && <p className={cn('mt-2', textErrorColor)}>{error}</p>}
    </div>
  )
}
